<template>
  <div data-testid="full-wysiwyg">
    <div v-if="label" class="input-title">{{ label }}</div>

    <VuetifyTiptap
      ref="editortiptap"
      v-model="modelValue"
      :disabled="disabled"
      :error-messages="errorMessages?.length ? errorMessages : null"
      data-testid="wysiwyg-editor"
    />
  </div>
</template>

<script setup>
import { defineProps, defineModel } from "vue";
const modelValue = defineModel("modelValue", {
  type: String,
  default: "",
});
defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
  label: {
    type: String,
    default: "",
  },
  errorMessages: {
    type: [String, Array],
    default: null,
  },
});
</script>

<style lang="scss" scoped>
:deep(.vuetify-pro-tiptap-editor) {
  border: 1px solid #d2d2d2;
  border-radius: 0.25rem;

  .vuetify-pro-tiptap-editor__btn-icon {
    color: #000;
    font-size: 1rem;
    &::before {
      color: #000 !important;
    }
  }

  .v-toolbar {
    background-color: #fff !important;
  }

  .vuetify-pro-tiptap-editor__content--disabled {
    background-color: #eceef3;
    &::after {
      background-color: transparent;
    }
  }
  .vuetify-pro-tiptap-editor__toolbar {
    background-color: #ffffff;
    border-bottom: 1px solid #d2d2d2;
  }

  .vuetify-pro-tiptap-editor__content {
    .ProseMirror {
      background-color: #f8f9ff;
      margin: 0 !important;
      min-height: 70px;
      p {
        margin: 10px 20px 10px 6px !important;
      }
    }
  }
}
</style>
